module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAANlBMVEVHcEz///////////////////////////////////////////////////////////////////+GUsxbAAAAEXRSTlMAcBMX+/AVdon8Fn1td/0Ue8WYPF4AAABnSURBVEjH7dM5DoAwDETRAAlgtpD7XxYKhFjGiV0hJE/9vlzZOZvt76ujzneeVpVP+3qlVxSHFxenFxYXLypuXlA8fLF4+UIBfLaAPlPMidmIfUtcsDQ48FxAAz4xBexDZe9us320DXK4EBhucR1+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sort-up.png
// module id = 373
// module chunks = 29